import * as React from 'react';

/**
 * Hook which returns the first value of `fn()`.
 */
export const useConstant = <T>(fn: () => T): T => {
  const ref = React.useRef<T>();

  if (!ref.current) {
    ref.current = fn();
  }

  return ref.current;
};
